import {
  Box as BoxBase, CardActionArea, Paper, alpha,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { TimelineContent, TimelineDot } from '@mui/lab';

type StylesType = {
  isActive?: boolean,
  lastItem?: boolean,
};

export const Dot = styled(TimelineDot, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<StylesType>(({ theme, isActive }) => ({
  margin: 0,
  marginLeft: isActive ? 0 : 2,
  padding: isActive ? 5 : 3,
  borderColor: isActive ? theme.palette.primary.main : theme.palette.action.disabled,
}));

export const CustomBox = styled(BoxBase, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<StylesType>(({ theme, isActive }) => ({
  backgroundColor: isActive ? theme.palette.primary.main : theme.palette.action.selected,
  color: isActive ? theme.palette.background.paper : theme.palette.neutral[500],
  boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
  borderBottomLeftRadius: 28,
  borderBottomRightRadius: 28,
}));

export const CardAction = styled(CardActionArea)({
  borderBottomLeftRadius: 28,
  borderBottomRightRadius: 28,
});

export const Card = styled(Paper)({
  width: '100%',
});

export const Content = styled(TimelineContent, {
  shouldForwardProp: (prop) => prop !== 'lastItem',
})<StylesType>(({ theme, lastItem }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  marginTop: '-24px',
  marginBottom: lastItem ? 0 : theme.spacing(6),
}));

export const InfoLabelBox = styled(BoxBase, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<StylesType>(({ theme, isActive }) => ({
  color: isActive ? theme.palette.primary.main : theme.palette.neutral[500],
  backgroundColor: isActive ? alpha(theme.palette.primary.main, 0.1) : theme.palette.neutral[100],
}));
